import { useState, useEffect, useRef } from "react";
import { Card, Button, message, Checkbox } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";

import { useMsal } from "@azure/msal-react"; //, useAccount
import { FormInput } from "../../Components/FormInputs";
import "./Login.css";

import { useNavigate, useLocation } from "react-router-dom";
import { logoutUser } from "../../Routes/LogOut";

import {
  useAuthStore,
  useNonPersistAuthStore,
} from "../../AuthStore/AuthStore";
import {
  GoogleReCaptcha,
  GoogleReCaptchaProvider,
} from "react-google-recaptcha-v3";
import { APIwithoutInterceptor } from "../../Axios/Axios";

import {
  getAuthenticationConfig,
  userLogin,


  getvalidateOtp,
  getForgotPassword,
  azuregenerateTokenForAuthentication

} from "../../Helpers/APIEndpoints/Endpoints";


import { encrypt } from "../../Helpers/Cryptography/CryptoV2";
import { InteractionStatus } from "@azure/msal-browser";
import { RoleEnum } from "../../Enum/RoleEnum";



type LoginPageProps = {
  type: string; // Define the expected type of the 'type' prop
};

type AzureLoginData = {
  accessToken: string;
  idToken: string;
  username: string;
};

const LoginPage: React.FC<LoginPageProps> = ({ type }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [isOtpfetched, setIsOtpfetched] = useState(false); // 1 for login, 2 for OTP
  const { instance, inProgress } = useMsal(); //, accounts
  const navigate = useNavigate();
  const [isforgotpassword, setIsforgotpassword] = useState(false);
  const [IsPasswordReset, setIsPasswordReset] = useState(false);
  const location = useLocation();
  type = location.state?.type ?? type;
  const [azureData, setAzureData] = useState<AzureLoginData | null>(null);

  const {
    setUserContext,
    commonContextParams,
    redirectUrlPostLogin,
    setredirectUrlPostLogin,
    setCommonContextRoleId,
  } = useAuthStore(); //setRememberMe, rememberMe, setAccessToken, setIdToken, setJWTAccessToken, setJWTRefreshToken
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [token, setToken] = useState("");

  const [formErrors, setFormErrors] = useState<any>({});
  let objError: any = {};

  const [disabled, setDisabled] = useState(false);

  // one sinlge usestate for the security policy, Raj Potdar, Date : 04-03-2025
  const [security, setSecurity] = useState({
    forgetPassword: false,
    rememberMe: false,
    captcha: false,
    otp: {
      enabled: false,
      modes: [],
      expiryMinutes: 0,
      length: 0,
    },
  });


  // This is for getting the user Context
  const getUserContext = () => {
    return {
      userAgent: navigator.userAgent,
      language: navigator.language,
      platform: navigator.platform,// NOSONAR : igonre
      screenResolution: `${window.screen.width}x${window.screen.height}`,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
  };

  const fetchAuthenticationConfig = async () => {
    try {
      const response = await APIwithoutInterceptor.post(
        getAuthenticationConfig
      );

      const data = response.data;
      return JSON.parse(data.data); // Ensure correct parsing
    } catch (error) {
      console.error("Error fetching authentication config:", error);
      throw error; // Re-throw for proper error handling
    }
  };

  const handleError = (messageText: string) => {
    setError(messageText);
    message.error(messageText);
  };

  // This is for the password validation
  const validateInputData = async (
    password: string,
    username: string | any[]
  ) => {
    try {
      // Parse the AuthType JSON string fetch the API
      const parsedData = await fetchAuthenticationConfig();

      // Extract the passwordPolicy
      // const passwordPolicy = parsedData.security.passwordPolicy;
      const useremailpolicy = parsedData.userNameType;

      if (username == null || username == "" || username == undefined) {

        objError["username_isempty"] = "Username is required";
      }

      if (!password && useremailpolicy === "Email") {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(username as string)) {
          objError["username_isempty"] = "Please enter a valid user email.";
        }
      }

      setFormErrors(objError);

      // Return false if there are errors, otherwise true
      return Object.keys(objError).length === 0;
    } catch (error) {
      console.error("Error validating password. Please try again:", error);
      return "Error validating password. Please try again.";
    }
  };

  const validateLogin = async () => {// NOSONAR : igonre
    setDisabled(true);
    try {

      const userContext = getUserContext();

      let isValidData = await validateInputData(password, username);
      if (password == null || password == "" || password == undefined) {
        objError["password_isempty"] = "Password is required";// NOSONAR : igonre
        setFormErrors(objError);
        isValidData = false;
      }
      if (isValidData) {
        const encryptedpassword = encrypt(password);
        console.log("Encrypted Password:", encryptedpassword);
        const response = await APIwithoutInterceptor.post(userLogin, {
          loginId: username,
          password: encryptedpassword,
          //ipAddress: ip,
          ...userContext,
        });

        const data = await response.data;

        if (data.message == "OK") {
          //response.ok &&
          if (data.data.isValidUser) {
            console.log("data.data", data.data);

            if (
              data.data.isPasswordChanged === null ||
              data.data.isPasswordChanged === false
            ) {

              setIsPasswordReset(true);
            }

            if (security.otp.enabled) {
              setIsOtpfetched(true); // Move to OTP step
            } else {
              message.success("Login successful!");
              if (redirectUrlPostLogin) {
                window.location.href = redirectUrlPostLogin;
                setredirectUrlPostLogin("");
              } else {
                navigate("/ComplaintsDashboard");
                //navigate("/RequestDashboard");
              }
            }

            message.success("Login validated. Please enter the OTP.");
          } else {
            message.error("InValid Login Credential!");
            navigate("login")
            setIsOtpfetched(false); // Stay on login step
          }
        } else {
          setError(data.message);
          message.error(data.message);
          setIsOtpfetched(false);
        }
      }
    } catch (error) {
      console.error("An error occurred while validating login. Please try again:", error);
      handleError(
        "An error occurred while validating login. Please try again."
      );
      setDisabled(false);
    }
    setTimeout(() => {
      setDisabled(false);
    }, 2000);
  };

  const validateOtp = async () => {
    setDisabled(true);
    if (otp.length < security.otp.length) {
      setError("OTP must be at least 6 characters long");
      return;
    }

    try {

      const userContext = getUserContext();

      const response = await APIwithoutInterceptor.post(getvalidateOtp, {
        loginId: username,
        otp: otp,

        ...userContext,
        isForgotPassword: isforgotpassword,
      });

      const data = await response.data;

      if (data.message == "OK") {

        setError("");
        if (isforgotpassword === true) {

          navigate("/forgot-password", {
            state: { type: type, username: username },
          });
        } else if (IsPasswordReset === true) {
          navigate("/reset-password", {
            state: { type: type, username: username },
          });
        } else {
          setUserContext(username, data.data?.Id);
          setCommonContextRoleId(data.data?.roleId);
          useNonPersistAuthStore
            .getState()
            .setJWTAccessToken(data.data.accessToken);
          message.success("Login successful!");
          if (redirectUrlPostLogin) {
            window.location.href = redirectUrlPostLogin;
            setredirectUrlPostLogin("");
          } else {
            navigate("/ComplaintsDashboard");
          }
        }
      } else {
        handleError(data.message ?? "Invalid OTP");
      }
    } catch (error) {
      handleError("An error occurred while validating OTP. Please try again.");
      console.error("Error:", error);
    }
    setTimeout(() => {
      setDisabled(false);
    }, 2000);
  };
  const hasRun = useRef(false);



  useEffect(() => {
    // Run only for Azure AD login type
    if (type !== "Entra") return;

    // Prevent multiple executions (React strict mode, rerenders, etc.)
    if (hasRun.current) return;

    // Avoid running while MSAL is already handling another login flow
    if (inProgress !== InteractionStatus.None) return;

    // Mark as executed so this effect won’t run again
    hasRun.current = true;

    const handleAzureLogin = async () => {
      try {
        // 1. Get the currently active Azure account
        const account = instance.getActiveAccount();

        if (!account) {
          // 2. If no account found → trigger Azure redirect login
          const parsedData = await fetchAuthenticationConfig();
          const scopes = parsedData.scopes ?? ["User.Read"];
          await instance.loginRedirect({ scopes });
          return; // 🔹 App reloads after redirect, so stop here
        }

        // 3. Silent token acquisition (no popup)
        const response = await instance.acquireTokenSilent({
          account,
          scopes: ["User.Read"],
        });

        // 4. Send token to backend to generate app-specific JWT
        const jwtResponse = await APIwithoutInterceptor.post(
          azuregenerateTokenForAuthentication,
          {
            loginId: account.username,
            accessToken: response.accessToken,
          }
        );

        if (jwtResponse.data.status === 0) {
          debugger;
          // alert(account.username)
          // 5. Save JWT + user info in local store/context
          const jwtData = jwtResponse.data.data;
          console.log('jwt', jwtData);
          useNonPersistAuthStore
            .getState()
            .setJWTAccessToken(jwtData.accessToken);
          setUserContext(account.username, jwtData.Id);
          setCommonContextRoleId(jwtData.roleId);

          //message.success("Azure AD login successful!");

          // 6. Navigate user after login
          if (redirectUrlPostLogin) {
            // If redirect URL exists → go there
            window.location.href = redirectUrlPostLogin;
            setredirectUrlPostLogin("");
          } else {
            //   // // Otherwise → default to /home
           
            console.log("Navigating based on rolsse:", commonContextParams?.roleId);
            commonContextParams?.roleId == RoleEnum.TaskActionOwner ? (
              navigate("/ActionDashboard")
            ) : commonContextParams?.roleId == RoleEnum.CorrectiveActionOwner ? (
              navigate("/CorrectiveActionDashboard")
            ) : (
              navigate("/ComplaintsDashboard")
            );

          }
        }
        else if (jwtResponse.data.status === 6) {
          message.error("InValid Login Credential!");
          setTimeout(() => {
            logoutUser(account.username);
          }, 2000);

        }
        else {
          // If backend rejects token
          message.error("Azure login JWT error: " + jwtResponse.data?.message);
        }
      } catch (err) {
        // Handle unexpected errors
        console.error("Azure login error:", err);
        handleError("Azure AD login failed. Please try again.");
      }
    };
    handleAzureLogin();
  }, [inProgress, type, instance]);


  const ssoLogin = async () => {
    const parsedData = await fetchAuthenticationConfig(); // Parse the JSON string
    // const azureAd = parsedAuthType.authentication.azureAd;
    const scopes = parsedData.scopes || ["User.Read"];

    const response = await instance.loginPopup({
      scopes: scopes, // Define your required scopes
    });

    if (response) {
      // Extract necessary data
      const { accessToken, idToken, account } = response;

      // API CALL for getting the jwt token
      const jwtresponse = await APIwithoutInterceptor.post(
        azuregenerateTokenForAuthentication,
        {
          loginId: account.username,
          accessToken: accessToken,
        }
      );

      if (jwtresponse?.data?.status === 0) {
        const jwtdata = await jwtresponse.data;

        useNonPersistAuthStore.getState().setJWTAccessToken(accessToken);

        // Store the data in the state
        setAzureData({
          accessToken,
          idToken,
          username: account.username,
        });
        setUserContext(account.username, jwtdata.data?.Id);
        setCommonContextRoleId(jwtdata.data?.roleId);

        //message.success("Azure AD login successful!");
        navigate("/ChatWithScreen", { state: { type: type } });
      } else {
        message.error("Error during Azure AD login");

        setTimeout(() => {
          navigate("/");
        }, 5000);
      }
    } else {
      console.error("Error during Azure AD login:", error);
    }
  };

  // New useEffect for the Custom Login
  useEffect(() => {
    const loginWithCustom = async () => {
      try {
        // Check if the login type is Custom
        if (type === "Custom" ||
          type === "Invite Only" ||
          type === "Dual Login"
        ) {
          // Parse AuthType and extract values
          const parsedData = await fetchAuthenticationConfig(); // Parse the JSON string
          setSecurity((prevState) => ({
            ...prevState,
            forgetPassword: parsedData.security.forgetPassword,
            rememberMe: parsedData.security.rememberMe,
            captcha: parsedData.security.captcha,
            otp: {
              ...prevState.otp,
              enabled: parsedData.security.otp?.enabled ?? false,
              modes: parsedData.security.otp?.modes ?? [],
              expiryMinutes: parsedData.security.otp?.expiryMinutes ?? 0,
              length: parsedData.security.otp?.length ?? 0,
            },
          }));
          console.log("captca:", token);

          // // this API call is for the message valdiation
          // const message = await APIwithoutInterceptor.post(
          //   getValidationMessages
          // );

          // var messageresponse = await message.data;
          // console.log("messageresponse:", messageresponse);


        }
      } catch (error) {
        console.error("Error during Custom login:", error);
        handleError("Custom login failed. Please try again.");
      }
    };

    // Trigger Custom login on component mount
    loginWithCustom();
  }, [type]);

  // Forgot Passowrd
  const updateforgotpasswordstate = () => {
    setPassword("");
    setError("");
    setIsforgotpassword(true);
  };
  const updateloginstate = () => {
    navigate("/");
  };

  const validateforgotpassword = async () => {
    setDisabled(true);
    try {
      let isValidData = await validateInputData(password, username);
      if (isValidData) {

        const response = await APIwithoutInterceptor.post(getForgotPassword, {
          LoginId: username || "",
        });

        const data = await response.data;
        console.log("Response Status:", response.status);
        console.log("Response Data:", data);

        if (data.message == "OK") {
          //response.ok &&
          setError("");
          message.success("OTP sent to your email ID.");
          setIsOtpfetched(true); // Move to OTP step
        } else {
          setError(data.message);
          message.error(data.message);
          setError("");
          setError("");
        }
      }
    } catch (error) {
      console.error("OTP :", error);
      throw error; // Re-throw for proper error handling
    }
    setTimeout(() => {
      setDisabled(false);
    }, 2000);
  };

  const setTokenFunc = (getToken: string) => {
    setToken(getToken);
  };

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => setError(""), 3000);
      return () => clearTimeout(timer); // Cleanup to prevent memory leaks
    }
  }, [error]);


  return (
    <div className="login-container">
      <Card className="login-card">
        {
          <div><h1 className="login-title">Login Page</h1>
            <p className="login-subtitle">Login to continue </p></div>
        }
        {(type === "Custom") && (
          <div>
            {isOtpfetched === false && (
              <>
                <div className="form-group text-center mt-3">
                  <FormInput
                    name="username"
                    label="User Name"
                    placeholder="Username"
                    inputType="text"
                    value={username}
                    onChange={(e: any) => setUsername(e.target.value)}
                    prefix={<UserOutlined />}
                    widthSize="large"
                  ></FormInput>
                  <p style={{ color: "red" }}>
                    {formErrors["username_isempty"]}
                  </p>
                </div>
                {isforgotpassword === false && (
                  <div className="form-group text-center mt-3">
                    <FormInput
                      name="password"
                      label="Password"
                      placeholder="Password"
                      inputType="password"
                      value={password}
                      onChange={(e: any) => setPassword(e.target.value)}
                      prefix={<LockOutlined />}
                      widthSize="large"
                    ></FormInput>
                    {/* password_isempty */}
                    <p style={{ color: "red" }}>
                      {formErrors["password_isempty"]}
                    </p>
                  </div>
                )}
                {/* Checkbox added here */}
                <div className="remember-forgot-container">
                  {/* Checkbox */}
                  {isforgotpassword === false && (
                    <>
                      {/* Remember Me Checkbox */}
                      {security.rememberMe && (
                        <Checkbox
                          checked={isChecked}
                          onChange={(e) => setIsChecked(e.target.checked)}
                        >
                          Remember Me
                        </Checkbox>
                      )}
                      {/* Forgot Password link */}
                      {security.forgetPassword && (
                        // <a
                        //   onClick={updateforgotpasswordstate}
                        //   className="forgot-password-link"
                        // >
                        //   Forgot Password?
                        // </a>

                        <button
                          type="button"
                          onClick={updateforgotpasswordstate}
                          className="forgot-password-link"
                        >
                          Forgot Password?
                        </button>
                      )}
                    </>
                  )}
                  {isforgotpassword === true && (

                    // <a
                    //   onClick={updateloginstate}
                    //   className="forgot-password-link"
                    // >
                    //   Back to Login.
                    // </a>
                    <button
                      type="button"
                      onClick={updateloginstate}
                      className="forgot-password-link"
                    >
                      Forgot Password?
                    </button>

                  )}
                </div>
                {error && (
                  <div className="login-error">
                    <span style={{ color: "red" }}>{error}</span>
                  </div>
                )}
                {/* Need to add the project in google for the recapta. */}
                {security.captcha && (
                  <div className="text-center mt-3">
                    <GoogleReCaptchaProvider reCaptchaKey="6LeNYM0qAAAAALUSeHz48n-OvsvHB29X_CosR2T5">
                      <GoogleReCaptcha
                        onVerify={setTokenFunc}

                      />
                    </GoogleReCaptchaProvider>
                  </div>
                )}

                <Button
                  type="primary"
                  disabled={disabled}
                  className="login-button"
                  onClick={
                    isforgotpassword === false
                      ? validateLogin
                      : validateforgotpassword
                  }
                >
                  {isforgotpassword === false ? "Login" : "Submit"}
                </Button>
              </>
            )}
            {isOtpfetched === true && (
              <div className="form-group text-center mt-3">
                <FormInput
                  name="otp"
                  label="OTP"
                  placeholder="enter the otp"
                  inputType="password"
                  value={otp}
                  onChange={(e: any) => setOtp(e.target.value)}
                  widthSize="large"
                ></FormInput>

                {error && (
                  <div className="login-error">
                    <span style={{ color: "red" }}>{error}</span>
                  </div>
                )}
                <Button
                  type="primary"
                  disabled={disabled}
                  className="login-button"
                  onClick={validateOtp}
                >
                  Verify OTP
                </Button>
              </div>
            )}
          </div>
        )}
        {(type === "Invite Only" || type === "Dual Login") && (
          <div>
            {isOtpfetched === false && (
              <>
                <div className="form-group text-center">
                  <FormInput
                    name="username"
                    label="User Name"
                    placeholder="Username"
                    inputType="text"
                    value={username}
                    onChange={(e: any) => setUsername(e.target.value)}
                    prefix={<UserOutlined />}
                    widthSize="large"
                  ></FormInput>
                  <p style={{ color: "red" }}>
                    {formErrors["username_isempty"]}
                  </p>
                </div>
                {isforgotpassword === false && (
                  <div className="form-group text-center">
                    <FormInput
                      name="password"
                      label="Password"
                      placeholder="Password"
                      inputType="password"
                      value={password}
                      onChange={(e: any) => setPassword(e.target.value)}
                      prefix={<LockOutlined />}
                      widthSize="large"
                    ></FormInput>
                    {/* password_isempty */}
                    <p style={{ color: "red" }}>
                      {formErrors["password_isempty"]}
                    </p>
                  </div>
                )}
                {/* Checkbox added here */}
                <div className="remember-forgot-container">
                  {/* Checkbox */}
                  {isforgotpassword === false && (
                    <>
                      {/* Remember Me Checkbox */}
                      {security.rememberMe && (
                        <Checkbox
                          checked={isChecked}
                          onChange={(e) => setIsChecked(e.target.checked)}
                        >
                          Remember Me
                        </Checkbox>
                      )}
                      {/* Forgot Password link */}
                      {security.forgetPassword && (
                        // <a
                        //   onClick={updateforgotpasswordstate}
                        //   className="forgot-password-link"
                        // >
                        //   Forgot Password?
                        // </a>

                        <button
                          type="button"
                          onClick={updateforgotpasswordstate}
                          className="forgot-password-link"
                        >
                          Forgot Password?
                        </button>
                      )}
                    </>
                  )}
                  {isforgotpassword === true && (
                    // <a
                    //   onClick={updateloginstate}
                    //   className="forgot-password-link"
                    // >
                    //   Back to Login.
                    // </a>
                    <button
                      type="button"
                      onClick={updateloginstate}
                      className="forgot-password-link"
                    >
                      Forgot Password?
                    </button>
                  )}
                </div>
                {error && (
                  <div className="login-error">
                    <span style={{ color: "red" }}>{error}</span>
                  </div>
                )}
                {/* Need to add the project in google for the recapta. */}
                {security.captcha && (
                  <div className="text-center mt-3">
                    <GoogleReCaptchaProvider reCaptchaKey="6LeNYM0qAAAAALUSeHz48n-OvsvHB29X_CosR2T5">
                      <GoogleReCaptcha onVerify={setTokenFunc} />
                    </GoogleReCaptchaProvider>
                  </div>
                )}

                <Button
                  type="primary"
                  disabled={disabled}
                  className="login-button"
                  onClick={
                    isforgotpassword === false
                      ? validateLogin
                      : validateforgotpassword
                  }
                >
                  {isforgotpassword === false ? "Login" : "Submit"}
                </Button>

                <div className="text-center mt-3">
                  {/* <Link href="/sso-login" style={{ fontSize: '16px' }}>
                            Login with SSO
                        </Link> */}
                  <button
                    className="login_sso"
                    // onClick={() => handleAzureLogin()}
                    onClick={() => ssoLogin()}
                  //disabled={chatBotContext?.isLocked}
                  >
                    Login with SSO
                  </button>
                </div>
              </>
            )}
            {isOtpfetched === true && (
              <div className="form-group text-center">
                <FormInput
                  name="otp"
                  label="OTP"
                  placeholder="enter the otp"
                  inputType="password"
                  value={otp}
                  onChange={(e: any) => setOtp(e.target.value)}
                  widthSize="large"
                ></FormInput>

                {error && (
                  <div className="login-error">
                    <span style={{ color: "red" }}>{error}</span>
                  </div>
                )}
                <Button
                  type="primary"
                  disabled={disabled}
                  className="login-button"
                  onClick={validateOtp}
                >
                  Verify OTP
                </Button>
              </div>
            )}
          </div>
        )}
      </Card>
    </div>
  );
};

export default LoginPage;
